import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import BlacklistAccounts from "./BlacklistAccounts";
import BlacklistCompanies from "./BlacklistCompanies";

import type { BlacklistType } from "../../../types";

export default function AddToBlacklistButton({
  type,
  size,
  isEmptyPlaceholderButton,
}: {
  type: BlacklistType;
  size: "sm" | "md";
  isEmptyPlaceholderButton: boolean;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);
  // biome-ignore lint/correctness/noUnusedVariables: Will be used in implementation
  const [failedUrls, setFailedUrls] = useState(null);

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  const MainComponent =
    type === "companies" ? BlacklistCompanies : BlacklistAccounts;

  return (
    <>
      <Button
        leftIcon={!isEmptyPlaceholderButton && <PlusCircle weight="fill" />}
        onClick={() => setIsOpen(true)}
        data-cy="blacklist-button"
        className="only:flex-1"
        size={size}
      >
        {isEmptyPlaceholderButton
          ? "Get started"
          : `Add ${type === "companies" ? "company" : "account"}`}
      </Button>
      <Component
        open={isOpen}
        onOpenChange={(open) => {
          if (!open) {
            setIsOpen(false);
          }
        }}
      >
        <Content size="xl" className="lg:h-140">
          <Header
            variant="border"
            title={failedUrls ? "Review blacklist upload" : `Blacklist ${type}`}
          />
          <MainComponent onClose={() => setIsOpen(false)} />
        </Content>
      </Component>
    </>
  );
}
